import { motion } from "framer-motion";
import { useCardsStore } from "@/zustand/store";
import { useDeleteCardAdmin } from "@/hooks/use-mutations";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import Throbber from "@/components/throbber";
import { Trash2 } from "lucide-react";

const DeleteCard = ({
  cardData,
  closeModal,
}: {
  cardData: Card;
  closeModal: () => void;
}) => {
  const { id: cardId } = cardData;
  const queryClient = useQueryClient();

  const { mutate: deleteCard, isPending: isDeletingCard } = useDeleteCardAdmin({
    id: cardId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["allCards"] });
      useCardsStore.setState({
        deleteIsOpen: false,
        cardId: null,
      });
    },
  });

  return (
    <div className="mx-auto flex flex-col items-center text-center">
      <div className="border-primary-100 flex size-16 items-center justify-center rounded-full border bg-[#FF6E7A] text-white">
        <Trash2 className="size-6" strokeWidth={1.5} />
      </div>
      <p className="mt-4 text-2xl font-medium text-white">Delete Card</p>
      <p className="text-sm text-white">
        Are you sure you want to delete this card?
      </p>

      <div className="mt-6 flex w-full gap-2">
        <Button
          variant={"outline"}
          onClick={() => closeModal()}
          className="border-primary-100 text-primary-100 grow rounded-md border bg-transparent"
        >
          Close
        </Button>
        <Button
          onClick={() => {
            deleteCard(cardId);
          }}
          className="grow rounded-md bg-[#FF6E7A] hover:bg-[#FF6E7A]/90"
        >
          {isDeletingCard ? <Throbber /> : "Continue"}
        </Button>
      </div>
    </div>
  );
};

export default DeleteCard;
